import COMMON_TOPIC_HEADERS from './commonTopicHeaders'
import TABLE_HEADERS from './tableHeaders'

export default Object.freeze({
  SORT_ORDER: 0,
  URI: '?type=paidLeave',
  JSON_VALUE: 'paidLeave',
  PRETTY_PRINT: 'Paid Leave - Miscellaneous',
  TOPICS: {
    ...COMMON_TOPIC_HEADERS,
    EFFECTIVE_DATE: {
      HEADER: 'Effective Date',
      ACCESSOR: 'effectiveDate'
    },
    ACCRUAL_RATE: {
      HEADER: 'Accrual Rate',
      ACCESSOR: 'accrualRate'
    },
    WEEKS_ALLOWED_PER_TYPE_OF_LEAVE: {
      HEADER: 'Weeks Allowed Per Type of Leave',
      ACCESSOR: 'weeksAllowedPerTypeOfLeave'
    },
    MAX_ACCRUAL_CAP: {
      HEADER: 'Max Accrual Cap',
      ACCESSOR: 'maxAccrualCap'
    },
    WAITING_PERIOD: {
      HEADER: 'Waiting Period Before Use',
      ACCESSOR: 'waitingPeriodBeforeUse'
    },
    COVERED_FAMILY_MEMBER: {
      HEADER: 'Covered Family Member',
      ACCESSOR: 'coveredFamilyMember'
    },
    ELIGIBLE_REASONS_FOR_LEAVE: {
      HEADER: 'Eligible Reasons for Leave',
      ACCESSOR: 'eligibleReasonsForLeave'
    }
  },
  get CSV_HEADER_ROW_VALUES() {
    return [
      TABLE_HEADERS.JURISDICTION_NAME.HEADER,
      TABLE_HEADERS.JURISDICTION_TYPE.HEADER,
      TABLE_HEADERS.PAID_LEAVE_TYPE.HEADER,
      this.TOPICS.EFFECTIVE_DATE.HEADER,
      this.TOPICS.ACCRUAL_RATE.HEADER,
      this.TOPICS.WEEKS_ALLOWED_PER_TYPE_OF_LEAVE.HEADER,
      this.TOPICS.MAX_ACCRUAL_CAP.HEADER,
      this.TOPICS.WAITING_PERIOD.HEADER,
      this.TOPICS.COVERED_FAMILY_MEMBER.HEADER,
      this.TOPICS.ELIGIBLE_REASONS_FOR_LEAVE.HEADER
    ]
  }
})
